import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import en from './locales/en';
import fr from './locales/fr';
import de from './locales/de';
import it from './locales/it';
import es from './locales/es';
import pt from './locales/pt';
import nl from './locales/nl';
import da from './locales/da';
import no from './locales/no';
import is from './locales/is';
import tr from './locales/tr';
import el from './locales/el';
import pl from './locales/pl';
import cs from './locales/cs';
import hu from './locales/hu';
import ro from './locales/ro';
import bg from './locales/bg';
import sk from './locales/sk';
import sl from './locales/sl';
import hr from './locales/hr';
import sq from './locales/sq';
import sr from './locales/sr';
import mk from './locales/mk';
import et from './locales/et';
import lv from './locales/lv';
import lt from './locales/lt';
import fi from './locales/fi';
import sv from './locales/sv';
import lb from './locales/lb';
import uk from './locales/uk';
import ca from './locales/ca';
import mt from './locales/mt';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      fr: { translation: fr },
      de: { translation: de },
      it: { translation: it },
      es: { translation: es },
      pt: { translation: pt },
      nl: { translation: nl },
      da: { translation: da },
      no: { translation: no },
      is: { translation: is },
      tr: { translation: tr },
      el: { translation: el },
      pl: { translation: pl },
      cs: { translation: cs },
      hu: { translation: hu },
      ro: { translation: ro },
      bg: { translation: bg },
      sk: { translation: sk },
      sl: { translation: sl },
      hr: { translation: hr },
      sq: { translation: sq },
      sr: { translation: sr },
      mk: { translation: mk },
      et: { translation: et },
      lv: { translation: lv },
      lt: { translation: lt },
      fi: { translation: fi },
      sv: { translation: sv },
      lb: { translation: lb },
      uk: { translation: uk },
      ca: { translation: ca },
      mt: { translation: mt },
    },
    fallbackLng: 'en',
    load: 'languageOnly',
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ['localStorage'],
      caches: ['localStorage'],
      lookupLocalStorage: 'camo-language',
    },
  });

export default i18n;

// Language metadata for the language switcher
export const LANGUAGES = [
  { code: 'en', name: 'English', nativeName: 'English', flag: '/flags/gb.png' },
  { code: 'fr', name: 'French', nativeName: 'Francais', flag: '/flags/fr.png' },
  { code: 'de', name: 'German', nativeName: 'Deutsch', flag: '/flags/de.png' },
  { code: 'it', name: 'Italian', nativeName: 'Italiano', flag: '/flags/it.png' },
  { code: 'es', name: 'Spanish', nativeName: 'Espanol', flag: '/flags/es.png' },
  { code: 'pt', name: 'Portuguese', nativeName: 'Portugues', flag: '/flags/pt.png' },
  { code: 'nl', name: 'Dutch', nativeName: 'Nederlands', flag: '/flags/nl.png' },
  { code: 'da', name: 'Danish', nativeName: 'Dansk', flag: '/flags/dk.png' },
  { code: 'no', name: 'Norwegian', nativeName: 'Norsk', flag: '/flags/no.png' },
  { code: 'is', name: 'Icelandic', nativeName: 'Islenska', flag: '/flags/is.png' },
  { code: 'tr', name: 'Turkish', nativeName: 'Turkce', flag: '/flags/tr.png' },
  { code: 'el', name: 'Greek', nativeName: 'Ellinika', flag: '/flags/gr.png' },
  { code: 'pl', name: 'Polish', nativeName: 'Polski', flag: '/flags/pl.png' },
  { code: 'cs', name: 'Czech', nativeName: 'Cestina', flag: '/flags/cz.png' },
  { code: 'hu', name: 'Hungarian', nativeName: 'Magyar', flag: '/flags/hu.png' },
  { code: 'ro', name: 'Romanian', nativeName: 'Romana', flag: '/flags/ro.png' },
  { code: 'bg', name: 'Bulgarian', nativeName: 'Balgarski', flag: '/flags/bg.png' },
  { code: 'sk', name: 'Slovak', nativeName: 'Slovencina', flag: '/flags/sk.png' },
  { code: 'sl', name: 'Slovenian', nativeName: 'Slovenscina', flag: '/flags/si.png' },
  { code: 'hr', name: 'Croatian', nativeName: 'Hrvatski', flag: '/flags/hr.png' },
  { code: 'sq', name: 'Albanian', nativeName: 'Shqip', flag: '/flags/al.png' },
  { code: 'sr', name: 'Serbian', nativeName: 'Srpski', flag: '/flags/rs.png' },
  { code: 'mk', name: 'Macedonian', nativeName: 'Makedonski', flag: '/flags/mk.png' },
  { code: 'et', name: 'Estonian', nativeName: 'Eesti', flag: '/flags/ee.png' },
  { code: 'lv', name: 'Latvian', nativeName: 'Latviesu', flag: '/flags/lv.png' },
  { code: 'lt', name: 'Lithuanian', nativeName: 'Lietuviu', flag: '/flags/lt.png' },
  { code: 'fi', name: 'Finnish', nativeName: 'Suomi', flag: '/flags/fi.png' },
  { code: 'sv', name: 'Swedish', nativeName: 'Svenska', flag: '/flags/se.png' },
  { code: 'lb', name: 'Luxembourgish', nativeName: 'Letzebuergesch', flag: '/flags/lu.png' },
  { code: 'uk', name: 'Ukrainian', nativeName: 'Ukrainska', flag: '/flags/ua.png' },
  { code: 'ca', name: 'Catalan', nativeName: 'Catala', flag: '/flags/es.png' },
  { code: 'mt', name: 'Maltese', nativeName: 'Malti', flag: '/flags/mt.png' },
] as const;
